import { useEffect, useState } from 'react';
import './App.css';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Calling from './api/Calling';
import { ToastContainer } from 'react-toastify';
import Navbar1 from './components/Navbar/Navbar1';
import Navbar2 from './components/Navbar/Navbar2';
import Login from './admin/Login/Login';
import Page404 from './components/page/Page404';
import Logout from './admin/Login/Logout';
import Error from './admin/Login/Error';
import StoryBrand from './admin/Story/StoryBrand';
import ViewsDashbord from './admin/ViewsDashbord';
import NativeAds from './admin/Ads/NavtiveAds/NativeAds';
import FullScreenAds from './admin/Ads/FullScreenAds/FullScreenAds';
import BannerAds from './admin/Ads/BannerAds/BannerAds';
import OpneAds from './admin/Ads/OpenAds/OpneAds';
import RewardAds from './admin/Ads/RewardAds/RewardAds';
import InHouseAds from './admin/Ads/InHouseAds/InHouseAds';
import EditeInHouseAds from './admin/Ads/InHouseAds/EditeInHouseAds';
import Controler from './admin/Controler/Controler.jsx';
import Reels from './admin/Story/Reels.jsx';
import Policy from './admin/Policy/Policy.jsx';
import LiveMatch from './admin/LiveMatch/LiveMatch.jsx';
import LiveMatchAd from './admin/LiveMatch/LiveMatchAd.jsx';
import Notification from './admin/Controler/Notification.jsx';
import LiveMatchAdWeb from './admin/LiveMatch/LiveMatchAdWeb.jsx';
import LiveMatchAdsHistory from './admin/LiveMatch/LiveMatchAdsHistory.jsx';
import InspackLock from './components/DevToolsRedirect .js';
import WebAds from './admin/Ads/WebAds/WebAds.jsx';
import StoryAds from './admin/Story/StoryAds.jsx';
import StoryVideo from './admin/Story/StoryVideo.jsx';
import UpdateStoryData from './admin/Story/UpdateStoryData.jsx';
import UpdateStoryAds from './admin/Story/UpdateStoryAds.jsx';
import VideoCategory from './admin/Video/VideoCategory.jsx';
import VideoAdd from './admin/Video/VideoAdd.jsx';
import VideoShow from './admin/Video/VideoShow.jsx';
import Client from './Client.jsx';
import IosNativeAds from './admin/Ads/ios/IosNavtiveAds/IosNativeAds.jsx';
import IosFullScreenAds from './admin/Ads/ios/IosFullScreenAds/IosFullScreenAds.jsx';
import IosBannerAds from './admin/Ads/ios/IosBannerAds/IosBannerAds.jsx';
import IosOpenAds from './admin/Ads/ios/IosOpenAds/IosOpneAds.jsx';
import IosRewardAds from './admin/Ads/ios/IosRewardAds/IosRewardAds.jsx';
import IosWebAds from './admin/Ads/ios/IosWebAds/IosWebAds.jsx';
import AdsTrack from './admin/Ads/AdsTrack/AdsTrack.jsx';
import LoginOtp from './admin/Login/LoginOtp.jsx';
import ForgetPw from './admin/Login/ForgetPw.jsx';
import ForgetPwOtp from './admin/Login/ForgetPwOtp.jsx';
import NewPw from './admin/Login/NewPw.jsx';


function App() {
  const [isAuthorized, setIsAuthorized] = useState(null); // Initially null
  const navigate = useNavigate();

  const handleLoginStatusChange = (status) => {
    if (status) {
      setIsAuthorized(true);
    }
  };

  const handleLogout = () => {
    setIsAuthorized(false);
    localStorage.removeItem('admin_download');
    navigate('/admin/panel/login');
  };

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const adminToken = localStorage.getItem('admin_download');
        if (!adminToken) {
          setIsAuthorized(false);

          return;
        }

        const resp = await Calling.AdminAuthCheck();
        setIsAuthorized(resp.status);
      } catch (error) {
        console.log(error);
        setIsAuthorized(false);
      }
    };

    checkAuthorization();
  }, []);

  return (
    <div className="flex roboto-regular bg-main-bg">
      <ToastContainer />
      <InspackLock />
      {isAuthorized && <Navbar1 />}
      <div className="flex ml-w-15 w-[100%]">
        {isAuthorized && <Navbar2 />}
        <Routes>
          {isAuthorized ? (
            <>
              {/* SortCut */}
              <Route path='/add/story' element={<StoryBrand />} />

              {/* Views Dashbord */}
              <Route path='/views/dashboard/:id' element={<ViewsDashbord />} />

              {/* InHouseAds */}
              <Route path='/manage/ads/inHouseAds/add' element={<InHouseAds />} />
              <Route path='/manage/ads/inHouseAds/edit/:id' element={<EditeInHouseAds />} />

              {/* Story */}
              <Route path='/update/story/video/:id' element={<UpdateStoryData />} />
              <Route path='/update/story/ads/:id' element={<UpdateStoryAds />} />
              <Route path='/add/story/Ad' element={<StoryAds />} />
              <Route path='/add/story/video' element={<StoryVideo />} />

              {/* Native Ads */}
              <Route path='/manage/ads/nativeAds/add' element={<NativeAds />} />

              {/* FullScreenAds */}
              <Route path='/manage/ads/fullScreenAds/add' element={<FullScreenAds />} />

              {/* Banner Ads */}
              <Route path='/manage/ads/bannerAds/add' element={<BannerAds />} />

              {/* Open Ads */}
              <Route path='/manage/ads/openAds/add' element={<OpneAds />} />

              {/* Reward Ads */}
              <Route path='/manage/ads/rewardAds/add' element={<RewardAds />} />

              {/* Tracks Ads */}
              <Route path='/manage/adstrack' element={<AdsTrack />} />

              {/* Web Ads */}
              <Route path='/manage/ads/webAds/add' element={<WebAds />} />

              {/* Controller */}
              <Route path='/controller' element={<Controler />} />

              {/* Reels */}
              <Route path='/story/add/reels' element={<Reels />} />

              {/* Policy */}
              <Route path='/policy' element={<Policy />} />

              {/* LiveMatch */}
              <Route path='/add/liveMatch' element={<LiveMatch />} />
              <Route path='/add/liveMatch/liveAd' element={<LiveMatchAd />} />
              <Route path='/add/liveMatch/liveAdWeb' element={<LiveMatchAdWeb />} />
              <Route path='/add/liveMatch/liveAdWeb/history' element={<LiveMatchAdsHistory />} />

              {/* Video */}
              <Route path='/add/video' element={<VideoAdd />} />
              <Route path='/add/video/category' element={<VideoCategory />} />
              <Route path='/show/video' element={<VideoShow />} />


              {/* Notifications */}
              <Route path='/notification' element={<Notification />} />
              <Route path="/" element={<StoryBrand />} />
              <Route path="/Logout" element={<Logout onLogout={handleLogout} />} />
              <Route path="*" element={<Error />} />


              {/* Ios */}
              {/* Native Ads */}
              <Route path='/manage/ads/ios/nativeAds/add' element={<IosNativeAds />} />

              {/* FullScreenAds */}
              <Route path='/manage/ads/ios/fullScreenAds/add' element={<IosFullScreenAds />} />

              {/* Banner Ads */}
              <Route path='/manage/ads/ios/bannerAds/add' element={<IosBannerAds />} />

              {/* Open Ads */}
              <Route path='/manage/ads/ios/openAds/add' element={<IosOpenAds />} />

              {/* Reward Ads */}
              <Route path='/manage/ads/ios/rewardAds/add' element={<IosRewardAds />} />

              {/* Web Ads */}
              <Route path='/manage/ads/ios/webAds/add' element={<IosWebAds />} />
            </>
          ) : (
            <>
              <Route path="/admin/panel/login" element={<Login />} />
              <Route path='/admin/panel/login/otp' element={<LoginOtp onLogin={handleLoginStatusChange} />} />
              <Route path='/admin/panel/forgetpw' element={<ForgetPw />} />
              <Route path='/admin/panel/forget/otp' element={<ForgetPwOtp />} />
              <Route path='/admin/panel/new/password' element={<NewPw />} />

              <Route path='/site/' element={<Client />} />
              <Route path="*" element={<Page404 />} />
            </>
          )}
        </Routes>
      </div>
    </div>
  );
}

export default App;
